/* eslint-disable react/require-default-props */
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import React from 'react';

export type SeverityType = 'info' | 'warning' | 'success' | 'error';

interface SeverityIconProps {
  type: SeverityType;
  style?: React.CSSProperties;
}

const getIconColor = (type: SeverityType) => {
  switch (type) {
    case 'warning':
      return '#FFB800';
    case 'info':
      return '#2196F3';
    case 'success':
      return '#4CAF50';
    case 'error':
      return '#F44336';
    default:
      return undefined;
  }
};

const SeverityIcon: React.FC<SeverityIconProps> = ({ type, style }) => {
  const defaultColor = getIconColor(type);
  const combinedStyle = { color: defaultColor, ...style };

  switch (type) {
    case 'warning':
      return <ReportProblemOutlinedIcon style={combinedStyle} />;
    case 'info':
      return <InfoOutlinedIcon style={combinedStyle} />;
    case 'success':
      return <CheckCircleOutlineIcon style={combinedStyle} />;
    case 'error':
      return <ErrorOutlineIcon style={combinedStyle} />;
    default:
      return null;
  }
};

export default SeverityIcon;
